import '../../Assets/css/common.css'

function StepProgressBar({ currentStep, totalSteps }) {
    return (
        <div className="step-progress-container">
            {Array.from({ length: totalSteps }).map((_, index) => (
                <div
                    key={index}
                    className={`step-progress-segment ${index < currentStep ? "active" : ""
                        }`}
                />
            ))}
        </div>
    );
}

export default StepProgressBar